import { Input } from '@mindmemobile/mm-shared-global';
import { observer } from 'mobx-react';
import React from 'react'; 

type Props = {
    type: string;
    onChange: (value: string) => void;
    hasError?: boolean;
    value: string;
    className?: string;
};

const RedirectInputs: React.FC<Props> = ({ type, value, onChange, hasError, className }) => {
    if (!type) return null;

    switch (type) {
        case 'Website':
            return (
                <Input
                    error={hasError}
                    placeholder="Website URL"
                    type="textarea"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={className}
                />
            );
        case 'MobilePage':
            return null;
        case 'ClickToEmail':
            return (
                <Input
                    error={hasError}
                    placeholder="Email address"
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="styled-input afterpay-text-input"
                />
            );
        case 'ClickToCall':
            return (
                <Input
                    error={hasError}
                    placeholder="Phone Number"
                    type="number"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className="styled-input afterpay-text-input"
                />
            );
        case 'ClickToText':
            return (
                <Input
                    error={hasError}
                    placeholder="Text Message"
                    type="textarea"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={className}
                />
            );
        default:
            return null;
    }
};

export default observer(RedirectInputs);
